import React from 'react';
import OrderItem from './OrderItem';

function OrderList({ orderList = [], orderType = null, ratingChanged = null, orderAgain = null, handlePopup = () => {} }) {
  return (
    <>
      {orderList.map((item, index) => (
        <OrderItem
          key={index}
          item={item}
          orderType={orderType}
          ratingChanged={ratingChanged}
          orderAgain={orderAgain}
          handlePopup={handlePopup}
        />
      ))}
    </>
  );
}

export default OrderList;
